import { useMemo } from "react";
import { Remote } from "../../../../core/components/remote/Remote.component";
import type { Block_SitesItemBlock_Fragment, PublishRecordFragment } from "@ihr-radioedit/inferno-webapi";
import { getCoastPreviousNextFeed } from "../../../../core/services/PubSub";
import { getPreviousNextFetchParams } from "../../lib/coastContent";
import { CoastPreviousNext } from "./CoastPreviousNext.component";

interface CoastPreviousNextLoaderProps {
    content: PublishRecordFragment;
    block: Block_SitesItemBlock_Fragment;
}

export const CoastPreviousNextLoader = ({ content, block }: CoastPreviousNextLoaderProps) => {
    const { queryVariables, cacheKey } = useMemo(() => getPreviousNextFetchParams(content), [content]);

    return (
        <Remote loader={() => getCoastPreviousNextFeed(queryVariables)} cacheKey={cacheKey}>
            {({ data }) => (data?.length ? <CoastPreviousNext block={block} items={data} curItem={content} /> : null)}
        </Remote>
    );
};

export default CoastPreviousNextLoader;
